import { ReactElement, memo } from 'react';

export const LTDMessaging = memo(function LTDMessaging(): ReactElement {
  return (
    <div className="mb-1 w-fit rounded bg-dollar/25 p-2 text-center text-xs font-semibold text-midnight md:mb-2">
      <span>One-time payment. Lifetime deal.</span>
    </div>
  );
});
